let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("liBrI")).then(() => parcelRequire('dxWU3'));